/**
 * .modal
 * Whenever we open #remote Bootstrap modal, we need to apply scrolls
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

$(document).ready(function(){

    "use strict";

    /**
     * Change the body class on show()
     *
     * @param  Event event
     * @return Void
     */
    $('.modal#remote').on('loaded.bs.modal', function (event) {
        $('body').addClass('modal-open');
    });
});
